export function isAttachment(value) {
    return ['scroll', 'fixed', 'local', 'initial', 'inherit'].includes(value);
}
//# sourceMappingURL=attachment.js.map